import defaultDowntime from './data/default_downtime.json';
import defaultGenders from './data/default_genders.json';
import defaultMonths from './data/default_months.json';

const DefaultTranslationProps = {
    GENDER_NON_BINARY: 'sync.components.gender.non_binary',
    TECH_PROB: 'sync.containers.user.oops_page.we_are_sorry_tech_prob',
    MONTH_JAN: 'sync.components.month.jan',
}

function injectGenders (translations) {
    if (!translations[DefaultTranslationProps.GENDER_NON_BINARY]) {
        return {
            ...translations,
            ...defaultGenders,
        };
    }
    return translations;
}

function injectDowntime (translations) {
    if (!translations[DefaultTranslationProps.TECH_PROB]) {
        return {
            ...translations,
            ...defaultDowntime,
        };
    }
    return translations;
}

function injectMonths (translations) {
    if (!translations[DefaultTranslationProps.MONTH_JAN]) {
        return {
            ...translations,
            ...defaultMonths,
        };
    }
    return translations;
}

function injectDefaults () {
    if (this.translations) {
        this.translations = injectGenders(this.translations);
        this.translations = injectDowntime(this.translations);
        this.translations = injectMonths(this.translations);
    }
}

export default injectDefaults;
